import type { ComponentProps } from 'react';
import { getDomainValue } from 'utils/domain';
import { ChevronSVG } from 'components/iconsSVG/chevron';
import { LabChevronDownIcon } from 'components/camperlab/icons/chevron-down';

export function InputChevron(props: ComponentProps<'svg'>) {
  const className = `size-3.5 text-inherit transition-transform ${props.className ?? ''}`;
  return getDomainValue({
    camper: <ChevronSVG aria-hidden {...props} className={className} />,
    nnormal: <ChevronSVG aria-hidden {...props} className={className} />,
    camperlab: <LabChevronDownIcon aria-hidden {...props} className={className} />,
  });
}
